import React from 'react';
import { presentationOptions } from '@/constants/states';
import CardsHeader from '@/components/cards/CardsHeader';
import { states } from '@/constants/lifecycle';
import { onScroll } from '@/hooks/paging';
import {
  columnCreatedOn,
  columnAssignee,
  columnTools,
  columnNameLink,
  columnDataset,
  columnRequester,
  columnWorkflowName,
  columnDatasetLink,
  columnRequestLink,
  columnRequest,
} from '@/constants/fields';
import TasksFilters from './TasksFilters';
import TaskCards from './TaskCards';
import TasksTable from './TasksTable';
import TasksPanelContainer from './TasksPanelContainer';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const buildColumns = ({ allowRequestLink, allowDatasetLink }) => {
  const columns = [
    columnNameLink,
    columnCreatedOn,
    columnAssignee,
    columnRequester,
    columnWorkflowName,
    columnTools];

  if (allowDatasetLink) { columns.push(columnDatasetLink); } else { columns.push(columnDataset); }
  if (allowRequestLink) { columns.push(columnRequestLink); } else { columns.push(columnRequest); }

  return columns;
};

const TasksPanelFull = ({ category, displayAs }) => {
  const state = Selectors.useTasksPanel({ category, displayAs });
  const fetchData = Events.useFetchRequestTasks(category);
  const togglePresentation = Events.useToggleTasksPresentation(category);
  const columns = buildColumns(state);

  return (
    <TasksPanelContainer category={category} className="aridhia-tasks-panel-full">
      {state.display === presentationOptions.CARDS && (
        <>
          <CardsHeader
            disabled={state.readStatus === states.PENDING}
            onClick={() => togglePresentation({ display: presentationOptions.TABLE })}
          >
            <TasksFilters category={category} className="aridhia-list-filter" />
          </CardsHeader>
          <TaskCards
            allowRequestLink={state.allowRequestLink}
            allowDatasetLink={state.allowDatasetLink}
            canEdit={state.canEdit}
            category={category}
            email={state.email}
            handleScroll={() => onScroll(fetchData, state)}
            items={state.tasks}
            readErrors={state.readErrors}
            readStatus={state.readStatus}
          />
        </>
      )}
      {state.display !== presentationOptions.CARDS && (
        <TasksTable
          canEdit={state.canEdit}
          category={category}
          columns={columns}
          currentPage={state.currentPage}
          email={state.email}
          fetchData={fetchData}
          pageCount={state.pageCount}
          pageSize={state.pageSize}
          readErrors={state.readErrors}
          readStatus={state.readStatus}
          tasks={state.tasks}
          togglePresentation={togglePresentation}
          total={state.total}
        />
      )}
    </TasksPanelContainer>
  );
};

export default TasksPanelFull;
